<template lang="pug">
  section.trivia-header
    img.logo-208(src="assets/images/logo-208.png", alt="Peugeot 208")
    img.txt-ana-tijoux(src="assets/images/txt-ana-tijoux.png", alt="Ana Tijoux")
    img.info(src="assets/images/info.png", alt="30 agosto")
</template>

<script>
  export default  {
    name: 'trivia-header',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .trivia-header {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1rem;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
  }
  img{
    max-height: 80px;
    &.txt-ana-tijoux{
      max-height: 40px;
    }
  }
  h1{
    display: flex;
    align-items: center;
    font-size: 1.2rem;
  }
</style>
